import { render, staticRenderFns } from "./market-table.vue?vue&type=template&id=971cf8ae&scoped=true&"
import script from "./market-table.vue?vue&type=script&lang=js&"
export * from "./market-table.vue?vue&type=script&lang=js&"
import style0 from "./market-table.vue?vue&type=style&index=0&id=971cf8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cf8ae",
  null
  
)

export default component.exports